import store from '@/store'
import ModuleBase from '@/modules/management/components/ModuleBase';
import ManagementDashboard from '@/modules/management/views/Dashboard';
import RevenueReport from '@/modules/management/views/RevenueReport';
import PartsReport from "@/modules/management/views/PartsReport";
import SUBDRevenueReport from '@/modules/management/views/SUBDRevenueReport';
import AccountsReceivable from '@/modules/management/views/AccountsReceivable';
import Budgets from '@/modules/management/views/Budgets';
import BudgetBase from '@/modules/management/components/budgets/BudgetBase';
import BudgetOverview from '@/modules/management/views/budgets/budgetDetail/Overview';
import ChartOfAccounts from '@/modules/management/views/accounting_setup/ChartOfAccounts';
import CreateJournalEntry from '@/modules/management/views/CreateJournalEntry';
import JournalEntry from '@/modules/management/views/JournalEntry';
import BalanceSheet from '@/modules/management/views/financial_reports/BalanceSheet';
import ProfitAndLoss from '@/modules/management/views/financial_reports/ProfitAndLoss';
import AccountTransactions from '@/modules/management/views/financial_reports/AccountTransactions';
import AccountTransactionsByReconciliation from '@/modules/management/views/financial_reports/AccountTransactionsByReconciliation';

const routes = [
  {
    path: '/management/',
    component: ModuleBase,
    meta: { appKey: 'management' },
    children: [
      {
        path: 'dashboard',
        component: ManagementDashboard,
        name: 'ManagementDashboard',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'subd-revenue',
        component: SUBDRevenueReport,
        name: 'SUBDRevenueReport',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
	path: 'revenue',
	component: RevenueReport,
	name: 'RevenueReport',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'ar',
        component: AccountsReceivable,
        name: 'AccountsReceivable',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
        next()
        }
      },
      {
	path: 'parts-report',
	component: PartsReport,
	name: 'PartsReport',
	beforeEnter: (to, from, next) => {
		store.dispatch('clearSubnav')
	next()
	}
	},
      {
        path: 'budgets',
        component: Budgets,
        name: 'Budgets',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'budget-detail/:id/',
        component: BudgetBase,
        children: [
          {
            path: 'overview',
            component: BudgetOverview,
            name: 'BudgetOverview'
          }
        ]
      },
      {
        path: 'chart-of-accounts/',
        component: ChartOfAccounts,
        name: 'ChartOfAccounts'
      },
      {
        path: 'journal-entry/',
        component: CreateJournalEntry,
        name:'CreateJournalEntry'
      },
      {
        path: 'journal-entry/:id?',
        component: JournalEntry,
        name: 'JournalEntry'
      },
      {
        path: 'balance-sheet/',
        component: BalanceSheet,
        name: 'BalanceSheet'
      },
      {
        path: 'account-transactions/',
        component: AccountTransactions,
        name: 'AccountTransactions'
      },
      {
        path: 'account-transactions-by-reconciliation/',
        component: AccountTransactionsByReconciliation,
        name: 'AccountTransactionsByReconciliation'
      },
      {
        path: 'profit-and-loss/',
        component: ProfitAndLoss,
        name: 'ProfitAndLoss'
      }
    ]
  }
]

export default routes
